import Swal from "sweetalert2";
import { ADDALLWHATAPPGROUP, GETALLWHATAPPGROUP } from "../../utils/api"
import axios from "../../utils/axios"
import { swalAlertPopProps } from "../../utils/commonUtils";

export const addWhatAppGroup=async(payload,callback)=>{
    

    await axios.post(ADDALLWHATAPPGROUP,payload).then((res)=>{
        Swal.fire({
            text: res?.text,
            icon: "success",
            ...swalAlertPopProps,
          });
        callback(res)
    })
}

export const getAllGroup=async(callback)=>{
    await axios.get(GETALLWHATAPPGROUP).then((res)=>{
        callback(res?.data)
    }).catch((err)=>{

    })
}

